import { render, staticRenderFns } from "./huahua.vue?vue&type=template&id=b0531ad8&scoped=true&"
import script from "./huahua.vue?vue&type=script&lang=js&"
export * from "./huahua.vue?vue&type=script&lang=js&"
import style0 from "./huahua.vue?vue&type=style&index=0&id=b0531ad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0531ad8",
  null
  
)

export default component.exports